import React from 'react';

import { ContainerHeader, TabContainer } from '~components';
import { faHandHoldingHeart } from '~components/icon';

import Budgets from './budgets/Budgets';
import Contributions from './contributions/Contributions';
import { PricePlans } from './price-plans';
import ServiceAssociations from './service-associations/ServiceAssociations';
import Services from './services/Services';

const tabs = [
  { id: 'sah-client-services', title: 'SaH Approved Services', component: Services },
  { id: 'sah-client-contributions', title: 'SaH Contributions', component: Contributions },
  // Disabled due to being currently redundant.
  // { id: 'sah-client-classifications', title: 'SaH Client Classifications', component: Classifications },
  { id: 'sah-client-budgets', title: 'SaH Budgets', component: Budgets },
  { id: 'sah-service-associations', title: 'Service Type Assocs.', component: ServiceAssociations },
  { id: 'sah-price-plans', title: 'Price Plans', component: PricePlans },
];

const ConfigContainer: React.FC = () => {
  return (
    <div className="p-2">
      <ContainerHeader icon={faHandHoldingHeart} iconSize="1x" className="info" dataCy="support-at-home-configs-header">
        Support At Home
      </ContainerHeader>
      <TabContainer tabs={tabs} />
    </div>
  );
};

export default ConfigContainer;
